export default __webpack_public_path__ + "static/media/logo_expressojk.1cdb7299.webp";